import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Client } from '../../../domain/data';
import { ClientRelation, ClientType, LegalGuardianType, Nature } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-contract-form-legal-person',
    templateUrl: './contract-form-legal-person.component.html',
    styleUrls: ['./contract-form-legal-person.component.scss'],
})
export class ContractFormLegalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public ClientType: typeof ClientType = ClientType;

    public attorneyInFact: Client;
    public disabledLegal = false;

    @Input()
    client: Client;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnInit() {
        this.createAttorneyInFact();
    }

    private createAttorneyInFact() {
        if (this.client.legalGuardians.length === 0) {
            this.attorneyInFact = new Client();
            this.attorneyInFact.docExpirationDatePermanent = false;
            this.attorneyInFact.phoneExonerate = false;
            this.attorneyInFact.emailExonerate = false;
            this.attorneyInFact.nature = Nature.NATURAL;
            this.attorneyInFact.type = ClientType.NATURAL_PERSON;
            this.attorneyInFact.legalGuardianType = LegalGuardianType.ATTORNEY_IN_FACT;
            this.attorneyInFact.legalGuardianRelation = ClientRelation.AUTHORIZED;

            this.client.addLegalGuardian(this.attorneyInFact);
        } else {
            this.attorneyInFact = this.client.legalGuardians[0];
        }
    }
}
